import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BuilderContext, useDrawer } from "react-flow-builder";
import { Form, Button, Input, Select, Radio, Checkbox, Modal, message } from "antd";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snack";
import CodeEditor from "@uiw/react-textarea-code-editor";
import info from "../../../../../../../images/info.png";
import sampleData from "../../sampleData.json"
import CopyToClipboard from "react-copy-to-clipboard";
import { CopyOutlined } from "@ant-design/icons";
const { TextArea } = Input;

const DBConfig = () => {
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  let _availabeDb = [];
  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(null);
  const [actionType, setActionType] = useState("");
  const [selectedDb, setSelectedDb] = useState("");
  const [availableDb, setAvailableDb] = useState("");
  const [isFIPS, setisFIPS] = useState(false);
  const [isSSL, setisSSL] = useState(false);
  const [withCol, setWithCol] = useState(false);
  const [dbType, setDbType] = useState("");
  const [selector, setSelector] = useState("");
  const skill = useSelector((state) => state.skillReducer.trainDraft);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [codeContent, setCodeContent] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const success = () => {
    message.success('Copied to clipboard');
  };

  useEffect(() => {
    // Fetch the data from sampleData using the key "GET_OUTLOOK_MAIL"
    const data = sampleData[14]["DB_QUERY"].data;

    const codeContent = JSON.stringify(data, null, 2);
    // Get the examples
    const codeExample = sampleData[14]["DB_QUERY"].Example;

    const headerContent = "Output variable to capture the response.\nBelow is the sample response."

    // Set the content to the state variables along with examples
    const fullContent = `${headerContent}\n\n${codeContent}\n\n${codeExample}`;
    setCodeContent(fullContent);
  }, []);

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };
  const addQueryToConnection = (arr, selectedDbId, currentNodeId) => {
    let found = arr.findIndex((i) => i.id == selectedDbId);
    if (found > -1) {
      // if (!arr[found].subActions?.includes(currentNodeId)) {
      //   let _payload = arr[found].subActions.push(currentNodeId);
      //   arr[found] = { ...arr[found], ..._payload };
      // }
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          addQueryToConnection(element.children, selectedDbId, currentNodeId);
        }
      });
    }
    return arr;
  };
  const findDBConnection = (arr) => {
    arr.forEach((element) => {
      if (
        [
          "branch",
          "condition",
          "loop",
          "loop-nodes",
          "try",
          "try-catch-node",
          "review",
          "review-node",
        ].includes(element.type)
      ) {
        findDBConnection(element.children);
      }
      if (["DB_CONNECTION"].includes(element.actionType)) {
        let _dbpayload = {
          label: element.databasename || element.servicename,
          value: element.id,
        };
        _availabeDb.push(_dbpayload);
      }
    });

    return _availabeDb;
  };

  const newVariables = useSelector((state=> state.skillReducer?.trainDraft?.RAW_DATA?.variables))

  const checkForDuplicateVariable = (userVariable) => {
    
    const variableExists = newVariables?.some((variable) => variable.id !== nodeData.id && variable.name === userVariable);
    if (variableExists) {
      dispatch(
        notify(
          "error",
          "Duplicate variable names are not allowed."
        )
      );
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    try {
      let updatedNode;
      const values = await form.validateFields();
    
      if (actionType === "" || actionType === "select") {
        dispatch(
          notify(
            "error",
            "Please select an operation."
          )
        );
        return;
      }
      let obj = {};
      let {
        skillReducer: { trainDraft },
      } = store.getState();
      if (actionType == "DB_CONNECTION") {
        let _tokenObj = {
          host: values.host,
          username: values.username,
          password: values.password,
          port: values.port,
          database: values?.databasename || values.servicename,
          type: values.db_type,
          ssl: isSSL
        };
    
        let _str = JSON.stringify(_tokenObj);
        let buff = Buffer.from(_str, "utf8");
        let _db_token = buff.toString("base64");
        obj.actionType = "DB_CONNECTION";
        obj.key = "connection";
        obj.label = "Connection";
        obj.databasename = values.databasename || "";
        obj.servicename = values.servicename || "";
        obj.db_type = values.db_type;
        obj.sid = values.sid || "";
        obj.host = values.host;
        obj.password = values.password;
        obj.port = values.port;
        obj.username = values.username;
        obj.db_token = _db_token;
        obj.selectorType = selector;
        obj.isFIPS = isFIPS;
        obj.ssl = isSSL;
        nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
        let newActions = findAndUpdate(nodes, nodeData.id, obj);
        store.dispatch(
          setDraft({
            ...trainDraft,
            RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
          })
        );
      }
      if (actionType == "DB_EXECUTE_QUERY") {
        obj.actionType = "DB_EXECUTE_QUERY";
        obj.key = "executequery";
        obj.label = "Execute Query";
        obj.query = values.query;
        const userVariable =values.variable;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        obj.variable = values.variable;
        obj.dbId = values.dbId;
        obj.withColumns = withCol;

        if (values.variable.includes(" ") || values.variable.includes("-")) {
          dispatch(
            notify(
              "error",
              "Invalid variable name. The use of '-' symbol and spaces are not allowed in variable names."
            )
          );
          return;
        } else {
          updatedNode = addQueryToConnection(
            skill?.RAW_DATA?.actions,
            selectedDb,
            nodeData.id
          );
          store.dispatch(
            setDraft({
              ...trainDraft,
              RAW_DATA: { ...trainDraft.RAW_DATA, actions: updatedNode },
            })
          );
          nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
          let newActions = findAndUpdate(updatedNode, nodeData.id, obj);
          store.dispatch(
            setDraft({
              ...trainDraft,
              RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
            })
          );
        }
      }

      cancel();
    } catch (error) {
      console.log("form error", error);
    }
  };

  useEffect(() => {
    setNodeData(node);
    setActionType(node.actionType);
    setDbType(node?.db_type);
    setisFIPS(node?.isFIPS);
    setisSSL(node?.ssl);
    setWithCol(node?.withColumns);
    getDBConnectionData();
    setSelector(node?.selectorType)
  }, [node]);

  const getDBConnectionData = async () => {
    let con = await findDBConnection(skill?.RAW_DATA?.actions);
    setAvailableDb(con);
  };
  const handleChecked = (e) => {
    console.log(e, "e");
    setisFIPS(e.target.checked);
  };

  const handleSSLChecked = (e) => {
    console.log(e, "e");
    setisSSL(e.target.checked);
  };

  const onChange = (value) => {
    console.log(`selected ${value}`);
    setSelectedDb(value);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };
  const handleDbType = (e) => {
    setDbType(e);
  };
  const fieldRadioChange = (e) => {
    setSelector(e.target.value);
  };
  const handleCheckedCol = (e) => {
    setWithCol(e.target.checked);
  };
  const renderActionType = (type) => {
    switch (type) {
      case "DB_CONNECTION":
        return (
          <div style={{ marginBottom: '11px' }}>
            <Form.Item name="db_type" label="Select Database Type">
              <Select onChange={(e) => handleDbType(e)}>
                <Select.Option value="mysql">My Sql</Select.Option>
                <Select.Option value="postgre">PostgreSQL</Select.Option>
                <Select.Option value="oracle">Oracle</Select.Option>
                <Select.Option value="mssql">MS SQL</Select.Option>
              </Select>
            </Form.Item>
            {dbType == "mssql" ? (
              <Radio.Group
                name="selectorType"
                onChange={(e) => fieldRadioChange(e)}
                value={selector || "winSelector"}
              >
                <Radio value="winSelector"> Windows Authentication </Radio>
                <Radio value="sqlSelector">SQL Server Authentication </Radio>
              </Radio.Group>
            ) : null}
            <Form.Item
              name="host"
              label="Host Name"
              rules={[{ required: true }]}
            >
              <Input placeholder="Host Name or IP Address" />
            </Form.Item>
            <Form.Item
              name="username"
              label="User Name"
              rules={[{ required: true }]}
              help="Please don't use variable"
            >
              <Input placeholder="User Name" />
            </Form.Item>{" "}
            <Form.Item
              name="password"
              label="Password"
              rules={[{ required: true }]}
            >
              <Input placeholder="Password" type="password" />
            </Form.Item>{" "}
            {dbType == "mssql" ? null : (
              <Form.Item name="port" label="Port" rules={[{ required: true }]}>
                <Input placeholder="Port" />
              </Form.Item>
            )}
            {dbType == "oracle" ? (
              <>
                <Form.Item
                  name="servicename"
                  label="Service Name"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Service Name" />
                </Form.Item>
                <Form.Item name="sid" label="SID" rules={[{ required: true }]}>
                  <Input placeholder="SID" />
                </Form.Item>
              </>
            ) : (
              <Form.Item
                name="databasename"
                label="Database Name"
                rules={[{ required: true }]}
              >
                <Input placeholder="Database Name" />
              </Form.Item>
            )}
            <Checkbox
              onChange={(e) => handleChecked(e)}
              checked={isFIPS == true ? true : false}
            >
              isFIPS implemented
            </Checkbox>
            <Checkbox
              onChange={(e) => handleSSLChecked(e)}
              checked={isSSL == true ? true : false}
            >
              SSL
            </Checkbox>
          </div>
        );
      case "DB_EXECUTE_QUERY":
        return (
          <div>
            <Form.Item name="dbId" label="Select DB connection">
              <Select
                style={{ width: 200 }}
                showSearch
                placeholder="Select DB connection"
                optionFilterProp="children"
                onChange={onChange}
                onSearch={onSearch}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={availableDb}
              />
            </Form.Item>

            <Form.Item
              name="query"
              label="Execute Query"
              rules={[{ required: true }]}
            >
              <TextArea rows={4} placeholder="Write your query here ...." />
            </Form.Item>
            <Form.Item
              name="variable"
              label="Variable"
              rules={[{ required: true }]}
            >
              <Input placeholder="Select Variable to Capture Result" />
            </Form.Item>
            <div style={{ position: 'relative' }}>
              <div className="ip-tl-label" style={{
                position: "absolute",
                display: "inline-block",
                margin: "0",
                top: "-76px",
                left: "60px"
              }}>

              <a
                class="tlt-icon tl-tooltip task-table-info"
                href="javascript:void(0)"
                onClick={showModal}
              >
                <img src={info} alt="" />
              </a>
            </div>
            </div>
            <Modal title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={codeContent} />
              <div style={{ position: 'absolute', top: 10, right: 50 }}>
                <CopyToClipboard text={codeContent} onCopy={() => setCopySuccess(true)}>
                  <Button onClick={success} type="primary" icon={<CopyOutlined />}>
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
            <Checkbox
              onChange={(e) => handleCheckedCol(e)}
              checked={withCol == true ? true : false}
            >
              {" "}
              Include Coloumn Names
            </Checkbox>
          </div>
        );
    }
  };

  const handleChange = async (e) => {
    setActionType(e);
  };

  return (
    <div>
      {nodeData ? (
        <div>
          <Form
            className=""
            form={form}
            initialValues={nodeData}
            // onValuesChange={(_, allFields) => {
            //   onChange(allFields);
            // }}
          >
            <div className="ant-row ant-form-item">
              <label className="ant-form-item-required">
                Select Operation
              </label>
              <div className="ant-col ant-form-item-control">
                <select
                  className="ant-input"
                  style={{ padding: "10px" }}
                  value={actionType}
                  onChange={(e) => handleChange(e.target.value)}
                >
                  <option value="select">Select</option>
                  <option value="DB_CONNECTION">Create Connection</option>

                  <option value="DB_EXECUTE_QUERY">Create Query</option>
                </select>
              </div>
            </div>

            {renderActionType(actionType)}
          </Form>
          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button type="primary" onClick={handleSubmit}>
              Save
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default DBConfig;
